import { useEffect } from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'
import TagManager from 'react-gtm-module'
// Components
import { Grid, Typography, useTheme, Link, Button } from '@mui/material'
// Icons
import { MdNavigateBefore, MdNavigateNext } from 'react-icons/md'
import { learningPhoneNumber } from '../utils/constants'

type IperiaLayoutPropsType = {
  productName?: string
  handleBack?: () => void
  handleNext: () => void
  submitting: boolean
  submittingNext: boolean
  alreadyConfirmed?: boolean
  /** When false, the primary next/confirm button is hidden (e.g. waiting for signature). */
  showNext?: boolean
  children: React.ReactNode
}

const IperiaLayout = ({
  children,
  productName,
  handleBack,
  handleNext,
  submitting,
  submittingNext,
  alreadyConfirmed = false,
  showNext = true,
}: IperiaLayoutPropsType) => {
  const theme = useTheme()
  const location = useLocation()
  const phoneNumber = learningPhoneNumber

  useEffect(() => {
    window.scrollTo(0, 0)
    TagManager.dataLayer({
      dataLayer: {
        event: 'Pageview',
        environment: import.meta.env.VITE_ENV === 'PRODUCTION',
        pagePath: window.location.pathname,
        pageTitle: `${window.document.title} - ${window?.location?.pathname?.split('/')?.[1] || ''}`,
      },
    })
  }, [location.pathname])

  return (
    <HelmetProvider>
      <Helmet>
        <title>{`Edumiam - IPERIA${productName ? ' - ' + productName : ''}`}</title>
      </Helmet>
      <Grid container>
        <Grid item xs={12}>
          <Grid container justifyContent="center">
            <Grid item xs={12} sx={{ my: { xs: 2, md: 6 } }}>
              {children}

              <Grid item sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                {handleBack && 
                  <Button
                    variant="outlined"
                    onClick={handleBack}
                    disabled={submitting}
                    sx={{ height: { xs: 45 } }}
                    startIcon={<MdNavigateBefore />}
                  >
                    Précédent
                  </Button>
                }
                {showNext && (
                  <Button
                    variant="contained"
                    onClick={handleNext}
                    disabled={submittingNext}
                    sx={{ height: { xs: 45 }, ml: 'auto' }}
                    endIcon={<MdNavigateNext />}
                  >
                    {submitting ? 'Sauvegarde...' : alreadyConfirmed ? 'Suivant' : 'Confirmer'}
                  </Button>
                )}
              </Grid>

              <Grid item container xs={12} justifyContent="space-between" sx={{ mt: 4 }}>
                <Grid item xs={12}>
                  <Typography
                    sx={{
                      fontSize: '0.875rem',
                      color: theme.palette.primary.dark,
                      textAlign: { xs: 'center', md: 'left' },
                    }}
                  >
                    Vous avez des questions ? Nous sommes disponibles au <Link
                      href={`tel:${phoneNumber.replace(/\s/g, '')}`}
                      underline="none"
                      sx={{
                        fontWeight: 700,
                        color: theme.palette.primary.main,
                        textDecoration: 'underline',
                      }}
                    >
                      {phoneNumber}
                    </Link>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </HelmetProvider>
  )
}

export default IperiaLayout
